// extracted by mini-css-extract-plugin
export var button = "_19-1";
export var featuredLink = "_19-4";
export var spinner = "_19-2";
export var spinnerContainer = "_19-3";
export var text = "_19-0";